/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentA2aAgentsRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  reactEnabled() {
    return true;
  }

  beforeModel() {
    if (this.appService.app.canUseStandalone) {
      this.router.transitionTo('apps.app.standalone.a2a-agents');
    }
  }
}

export default ReactRoute(AutomationFinAIAgentA2aAgentsRoute, {
  overrideRenderTemplate: false,
});
